import { Drawer, Spin, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { IValueBoolean } from "@/ts/common-types";
import { setShowMediaPlanChangeLogs } from "@/features/gridDataSlice";
import { useEffect, useState } from "react";
import {
    getMediaPlanChangeLogs,
    internationalizeNumericValue,
} from "@/ts/utils";
import dayjs from "dayjs";

type TMediaPlanChangeLogs = {
    planId: number;
};

const MediaPlanChangeLogs: React.FC<TMediaPlanChangeLogs> = ({ planId }) => {
    const dispatch = useDispatch();

    const [changeLogsData, setChangeLogsList] = useState(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const showMediaPlanChangeLogs = useSelector(
        (state: { showMediaPlanChangeLogs: IValueBoolean }) =>
            state.showMediaPlanChangeLogs.value
    );

    useEffect(() => {
        getMediaPlanChangeLogs(planId)
            .then((logsData) => {
                setIsLoading(true);
                setChangeLogsList(logsData);
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                console.error(err);
            });
    }, []);

    const columns = [
        {
            title: "Plan Level",
            dataIndex: "section",
            key: "section",
        },
        {
            title: "Record",
            dataIndex: "record_id",
            key: "record_id",
            render: (text: string) => (
                <Tooltip title={text}>
                    {text.length > 25 ? `${text.slice(0, 25)}...` : text}
                </Tooltip>
            ),
        },
        {
            title: "Attribute",
            dataIndex: "attribute",
            key: "attribute",
        },
        {
            title: "From",
            dataIndex: "from_audit",
            key: "from_audit",
            render: (value: number) => internationalizeNumericValue(value),
        },
        {
            title: "To",
            dataIndex: "to_audit",
            key: "to_audit",
            render: (value: number) => internationalizeNumericValue(value),
        },
        {
            title: "Date and time",
            dataIndex: "modified_at",
            key: "modified_at",
            render: (dateString: string) =>
                dayjs(dateString).format("DD MMM YYYY HH:mm"),
        },
        {
            title: "Modified by",
            dataIndex: "modified_by",
            key: "modified_by",
        },
    ];

    return (
        <>
            <Drawer
                title="Change Log"
                placement="right"
                width={1000}
                onClose={() => dispatch(setShowMediaPlanChangeLogs(false))}
                open={showMediaPlanChangeLogs}
            >
                {isLoading ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "70vh",
                        }}
                    >
                        <Spin tip="Loading" size="large"></Spin>
                    </div>
                ) : (
                    <>
                        <Table
                            columns={columns}
                            dataSource={changeLogsData}
                            pagination={{ pageSize: 10 }}
                        />
                    </>
                )}
            </Drawer>
        </>
    );
};

export default MediaPlanChangeLogs;
